import { Button } from "frontend/canvas-designer-new/elements-toolbar/toolbar-buttons";
import { TrashIcon } from "frontend/icons/trash-icon";

export function AddColumnButton({ onChange }: { onChange: (newValue: string, addUndo: boolean) => void }) {
  return (
    <Button onClick={() => onChange("", true)} tooltip="Add column to table">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" fill="none">
        <path fill="#fff" d="M10.3 8.8V5.1H8.7v3.7H5v1.6h3.7v3.7h1.6v-3.7H14V8.8h-3.7Z" />
        <path stroke="#fff" strokeWidth="1.5" d="M.75 0v20" />
      </svg>
    </Button>
  );
}

export function AddRowButton({ onChange }: { onChange: (newValue: string, addUndo: boolean) => void }) {
  return (
    <Button onClick={() => onChange("", true)} tooltip="Add row to table">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" fill="none">
        <path fill="#fff" d="M11.2 10.3h3.7V8.7h-3.7V5H9.6v3.7H5.9v1.6h3.7V14h1.6v-3.7Z" />
        <path stroke="#fff" strokeWidth="1.5" d="M20 .75H0" />
      </svg>
    </Button>
  );
}

export function DeleteButton({ onClick, tooltip }: { onClick: () => void; tooltip: string }) {
  return (
    <Button onClick={onClick} tooltip={tooltip}>
      <TrashIcon size={20} />
    </Button>
  );
}
